module.exports = __webpack_public_path__ + "static/logo-defa5493918e871bdb24615e644a19c9.svg";